import React from 'react';

const TemplatesContext = React.createContext();

export default TemplatesContext;
